import React from 'react';
import { Anchor, Box, costFormater, LinkIcon, List, Text, useResponsive } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { useGetFundIcon } from '@/modules/investments/hooks';

import { FundPayload } from './Funds';
interface Props extends FundPayload {
  isHighlighted?: boolean;
  onClick: () => void;
}
const FundsItem: React.FC<Props> = ({
  id = '',
  logo,
  title,
  ticker,
  value,
  election,
  color,
  categoryTitle,
  sharePrice = 0,
  shares,
  isHighlighted,
  researchURL,
  onClick,
}) => {
  const handleGetFundIcon = useGetFundIcon();
  const { isMobile } = useResponsive();
  if (isMobile) {
    return (
      <List.Item
        testId={`funds_item_${id}`}
        isHighlighted={isHighlighted}
        id={id}
        pad="s"
        align="center"
        justify="between"
        key={id}
        height={{ min: '76px' }}
        round="container1Round"
        onClick={onClick}
      >
        <Box direction="row" align="center">
          <div>
            {handleGetFundIcon({
              image: logo,
              // status: status,
              isGreyMode: false,
              isNullMode: true,
            })}
          </div>
          <Box direction="column" margin={{ left: 'spacing8' }} pad={{ right: 'spacing8' }}>
            <List.Item.Text data-testId={`funds_item_${id}_title`} title={title} truncate weight={700}>
              {title}
            </List.Item.Text>
            <List.Item.Text
              data-testId={`funds_item_${id}_ticker`}
              weight={500}
              size="small"
              color="textSecondary"
            >
              {ticker}
            </List.Item.Text>
          </Box>
        </Box>
        <div>
          <Box direction="column" align="end">
            <List.Item.Text weight={700} size="large" data-testId={`funds_item_${id}_amount`}>
              {costFormater(value, true)}
            </List.Item.Text>

            <List.Item.Text size="large" data-testId={`funds_item_${id}_election`} weight={400}>
              {`${election || 0}%`}
            </List.Item.Text>
          </Box>
        </div>
      </List.Item>
    );
  }
  return (
    <List.Item
      testId={`funds_item_${id}`}
      isHighlighted={isHighlighted}
      id={id}
      pad="s"
      key={id}
      height={{ min: '76px' }}
      round="container1Round"
    >
      <Box width="12px"></Box>
      <Box direction="row" style={{ flex: 12 }}>
        <Box>
          {handleGetFundIcon({
            image: logo,
            // status: status,
            isGreyMode: false,
            isNullMode: true,
          })}
        </Box>
        <Box direction="column" margin={{ left: 's' }} pad={{ right: 'l' }}>
          <List.Item.Text data-testId={`funds_item_${id}_title`} title={title} truncate weight={700}>
            {title}
          </List.Item.Text>
          <List.Item.Text
            data-testId={`funds_item_${id}_ticker`}
            weight={500}
            size="small"
            color="textSecondary"
          >
            {ticker}
          </List.Item.Text>
        </Box>
      </Box>

      <Box style={{ flex: 4 }}>
        <Box direction="row" align="center" pad={{ right: 'l' }}>
          <div>
            <Box width="10px" height="10px" round="snackbarRound" background={color}></Box>
          </div>
          <Text
            weight={400}
            data-testid={`funds_item_${id}_category`}
            title={categoryTitle}
            truncate
            margin={{ left: 'xxs' }}
          >
            {categoryTitle}
          </Text>
        </Box>
      </Box>

      <Box style={{ flex: 2 }}>
        <List.Item.Text data-testid={`funds_item_${id}_shares`} weight={400} margin={{ right: 'l' }}>
          {shares || EMPTY_FIELD_VALUE}
        </List.Item.Text>
      </Box>
      <Box style={{ flex: 3 }}>
        <List.Item.Text data-testid={`funds_item_${id}_share-price`} weight={400} margin={{ right: 'l' }}>
          {sharePrice
            ? costFormater(sharePrice, {
                isPrecision: true,
              })
            : EMPTY_FIELD_VALUE}
        </List.Item.Text>
      </Box>

      <Box style={{ flex: 2 }}>
        <List.Item.Text data-testId={`funds_item_${id}_election`} margin={{ right: 'l' }} weight={400}>
          {`${election || 0}%`}
        </List.Item.Text>
      </Box>
      <Box style={{ flex: 3 }}>
        <List.Item.Text weight={700} data-testId={`funds_item_${id}_amount`}>
          {costFormater(value, true)}
        </List.Item.Text>
      </Box>
      <Box width="72px">
        {researchURL ? (
          <Anchor target="_blank" href={researchURL} data-testId={`funds_item_${id}_link`}>
            <Box direction="row" align="center" justify="center" width="24px">
              <LinkIcon size="16px" color="iconPrimary" />
            </Box>
          </Anchor>
        ) : (
          <Box width="24px" />
        )}
      </Box>
      <Box width="12px"></Box>
    </List.Item>
  );
};
export default FundsItem;
